var map = {
	"./bg-BG.json": 2913,
	"./ca-ES.json": 2914,
	"./cs-CZ.json": 2915,
	"./de-DE.json": 2916,
	"./el-GR.json": 2917,
	"./en-US.json": 1513,
	"./es-ES.json": 2918,
	"./et-EE.json": 2919,
	"./fi-FI.json": 2920,
	"./fr-FR.json": 2921,
	"./he-IL.json": 2922,
	"./it-IT.json": 2923,
	"./ja-JP.json": 2924,
	"./ko-KR.json": 2925,
	"./nb-NO.json": 2926,
	"./nl-NL.json": 2927,
	"./nn-NO.json": 2928,
	"./pl-PL.json": 2929,
	"./pt-BR.json": 2930,
	"./ro-RO.json": 2931,
	"./ru-RU.json": 2932,
	"./sk-SK.json": 2933,
	"./sv-SE.json": 2934,
	"./tr-TR.json": 2935,
	"./zh-CN.json": 2936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2912;